// Import the functions you need from the SDKs you need
import firebase from "firebase/app";

import 'firebase/auth';


// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCFqGL5LzfIFEmUggZ-rWfT15QLUuSEG9M",
    authDomain: "reactfirebasev8authtemplate.firebaseapp.com",
    projectId: "reactfirebasev8authtemplate",
    storageBucket: "reactfirebasev8authtemplate.appspot.com",
    messagingSenderId: "420992132746",
    appId: "1:420992132746:web:b2372863b319ce21b56f73"
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);

const firebaseAuth = firebase.auth();

export default firebaseAuth;

export const provider = new firebase.auth.GoogleAuthProvider();